import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OEM_ERROR_CODE = createActionTypes('FETCH_OEM_ERROR_CODE');
export const GET_OEM_ERROR_CODE = createActionTypes('GET_OEM_ERROR_CODE');
export const CREATE_OEM_ERROR_CODE = createActionTypes('CREATE_OEM_ERROR_CODE');
export const UPDATE_OEM_ERROR_CODE = createActionTypes('UPDATE_OEM_ERROR_CODE');
export const DELETE_OEM_ERROR_CODE = createActionTypes('DELETE_OEM_ERROR_CODE');
export const CREATE_BULK_ERROR_CODE = createActionTypes('CREATE_BULK_ERROR_CODE');
